// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeCouponApi = class EdgeCouponApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param GetEnrollmentDetailsRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async couponGetEnrollmentDetails(GetEnrollmentDetailsRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/GetEnrollmentDetails';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetEnrollmentDetailsRequestModel' is not null or undefined
        if (GetEnrollmentDetailsRequestModel === null || GetEnrollmentDetailsRequestModel === undefined) {
            throw new Error('Required parameter GetEnrollmentDetailsRequestModel was null or undefined when calling couponGetEnrollmentDetails.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetEnrollmentDetailsRequestModel, "GetEnrollmentDetailsRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponGetEnrollmentDetailsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param CouponDocumentsSubmitDocumentsSubmitDocumentsRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentsSubmitDocuments(CouponDocumentsSubmitDocumentsSubmitDocumentsRequest, x_program_id) {
        const _url_ = '/edge/coupon/Documents/submitDocuments';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CouponDocumentsSubmitDocumentsSubmitDocumentsRequest' is not null or undefined
        if (CouponDocumentsSubmitDocumentsSubmitDocumentsRequest === null || CouponDocumentsSubmitDocumentsSubmitDocumentsRequest === undefined) {
            throw new Error('Required parameter CouponDocumentsSubmitDocumentsSubmitDocumentsRequest was null or undefined when calling documentsSubmitDocuments.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CouponDocumentsSubmitDocumentsSubmitDocumentsRequest, "CouponDocumentsSubmitDocumentsSubmitDocumentsRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponDocumentsSubmitDocumentsSubmitDocumentsResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param ExtEnrollmentRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentBasicEnrollment(programId, ExtEnrollmentRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Enrollment/basicEnrollment/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentBasicEnrollment.');
        }
        // verify required parameter 'ExtEnrollmentRequestModel' is not null or undefined
        if (ExtEnrollmentRequestModel === null || ExtEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentRequestModel was null or undefined when calling enrollmentBasicEnrollment.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentRequestModel, "ExtEnrollmentRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentBasicEnrollmentProgramIdBasicEnrollmentResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param ExtEnrollmentCommTypeUpdateRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentCommunicationTypeUpdate(programId, ExtEnrollmentCommTypeUpdateRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Enrollment/communicationTypeUpdate/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentCommunicationTypeUpdate.');
        }
        // verify required parameter 'ExtEnrollmentCommTypeUpdateRequestModel' is not null or undefined
        if (ExtEnrollmentCommTypeUpdateRequestModel === null || ExtEnrollmentCommTypeUpdateRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentCommTypeUpdateRequestModel was null or undefined when calling enrollmentCommunicationTypeUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentCommTypeUpdateRequestModel, "ExtEnrollmentCommTypeUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param ExtEnrollmentUpdateRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentDemographicsUpdate(programId, ExtEnrollmentUpdateRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Enrollment/demographicsUpdate/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentDemographicsUpdate.');
        }
        // verify required parameter 'ExtEnrollmentUpdateRequestModel' is not null or undefined
        if (ExtEnrollmentUpdateRequestModel === null || ExtEnrollmentUpdateRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentUpdateRequestModel was null or undefined when calling enrollmentDemographicsUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentUpdateRequestModel, "ExtEnrollmentUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentDemographicsUpdateProgramIdDemographicsUpdateResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param ExtEnrollmentInsVerRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentEnrollmentWithInsurance(programId, ExtEnrollmentInsVerRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Enrollment/enrollmentWithInsurance/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentEnrollmentWithInsurance.');
        }
        // verify required parameter 'ExtEnrollmentInsVerRequestModel' is not null or undefined
        if (ExtEnrollmentInsVerRequestModel === null || ExtEnrollmentInsVerRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentInsVerRequestModel was null or undefined when calling enrollmentEnrollmentWithInsurance.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentInsVerRequestModel, "ExtEnrollmentInsVerRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param ExtEnrollmentPatientLookupRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async enrollmentPatientMedicalBenefit(programId, ExtEnrollmentPatientLookupRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Enrollment/patientMedicalBenefit/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling enrollmentPatientMedicalBenefit.');
        }
        // verify required parameter 'ExtEnrollmentPatientLookupRequestModel' is not null or undefined
        if (ExtEnrollmentPatientLookupRequestModel === null || ExtEnrollmentPatientLookupRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentPatientLookupRequestModel was null or undefined when calling enrollmentPatientMedicalBenefit.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentPatientLookupRequestModel, "ExtEnrollmentPatientLookupRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponEnrollmentPatientMedicalBenefitProgramIdPatientMedicalBenefitResponse");
        }
        return response;
    }
    /**
     *
     * @param CouponMemberMemberNumberStatusMemberNumberStatusRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async memberMemberNumberStatus(CouponMemberMemberNumberStatusMemberNumberStatusRequest, x_program_id) {
        const _url_ = '/edge/coupon/Member/MemberNumberStatus';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CouponMemberMemberNumberStatusMemberNumberStatusRequest' is not null or undefined
        if (CouponMemberMemberNumberStatusMemberNumberStatusRequest === null || CouponMemberMemberNumberStatusMemberNumberStatusRequest === undefined) {
            throw new Error('Required parameter CouponMemberMemberNumberStatusMemberNumberStatusRequest was null or undefined when calling memberMemberNumberStatus.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CouponMemberMemberNumberStatusMemberNumberStatusRequest, "CouponMemberMemberNumberStatusMemberNumberStatusRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMemberNumberStatusMemberNumberStatusResponse");
        }
        return response;
    }
    /**
     *
     * @param CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async memberMemberNumberStatusWithProgram(CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest, x_program_id) {
        const _url_ = '/edge/coupon/Member/MemberNumberStatusWithProgram';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest' is not null or undefined
        if (CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest === null || CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest === undefined) {
            throw new Error('Required parameter CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest was null or undefined when calling memberMemberNumberStatusWithProgram.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest, "CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMemberNumberStatusWithProgramMemberNumberStatusWithProgramResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async memberMoveMemberNumberBySurveyQuestion(programId, ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Member/MoveMemberNumberBySurveyQuestion/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling memberMoveMemberNumberBySurveyQuestion.');
        }
        // verify required parameter 'ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel' is not null or undefined
        if (ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel === null || ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel === undefined) {
            throw new Error('Required parameter ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel was null or undefined when calling memberMoveMemberNumberBySurveyQuestion.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel, "ExtEnrollmentMoveMemberNumberBySurveyQuestionRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberMoveMemberNumberBySurveyQuestionProgramIdMoveMemberNumberBySurveyQuestionResponse");
        }
        return response;
    }
    /**
     *
     * @param CouponMemberReplaceCardReplaceCardRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async memberReplaceCard(CouponMemberReplaceCardReplaceCardRequest, x_program_id) {
        const _url_ = '/edge/coupon/Member/ReplaceCard';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CouponMemberReplaceCardReplaceCardRequest' is not null or undefined
        if (CouponMemberReplaceCardReplaceCardRequest === null || CouponMemberReplaceCardReplaceCardRequest === undefined) {
            throw new Error('Required parameter CouponMemberReplaceCardReplaceCardRequest was null or undefined when calling memberReplaceCard.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CouponMemberReplaceCardReplaceCardRequest, "CouponMemberReplaceCardReplaceCardRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponMemberReplaceCardReplaceCardResponse");
        }
        return response;
    }
    /**
     *
     * @param programId
     * @param MedicalBenefitRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientMedicalBenefitLookUp(programId, MedicalBenefitRequest, x_program_id) {
        const _url_ = '/edge/coupon/Patient/medicalBenefitLookUp/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling patientMedicalBenefitLookUp.');
        }
        // verify required parameter 'MedicalBenefitRequest' is not null or undefined
        if (MedicalBenefitRequest === null || MedicalBenefitRequest === undefined) {
            throw new Error('Required parameter MedicalBenefitRequest was null or undefined when calling patientMedicalBenefitLookUp.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(MedicalBenefitRequest, "MedicalBenefitRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponPatientMedicalBenefitLookUpProgramIdMedicalBenefitLookUpResponse");
        }
        return response;
    }
    /**
     *
     * @param PatientSearchRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientPatientSearch(PatientSearchRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Patient/patientSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PatientSearchRequestModel' is not null or undefined
        if (PatientSearchRequestModel === null || PatientSearchRequestModel === undefined) {
            throw new Error('Required parameter PatientSearchRequestModel was null or undefined when calling patientPatientSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PatientSearchRequestModel, "PatientSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponPatientPatientSearchPatientSearchResponse");
        }
        return response;
    }
    /**
     *
     * @param RedemptionListRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async redemptionFullRedemptionList(RedemptionListRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Redemption/fullRedemptionList';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'RedemptionListRequestModel' is not null or undefined
        if (RedemptionListRequestModel === null || RedemptionListRequestModel === undefined) {
            throw new Error('Required parameter RedemptionListRequestModel was null or undefined when calling redemptionFullRedemptionList.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(RedemptionListRequestModel, "RedemptionListRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponRedemptionFullRedemptionListFullRedemptionListResponse");
        }
        return response;
    }
    /**
     *
     * @param RedemptionListRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async redemptionList(RedemptionListRequestModel, x_program_id) {
        const _url_ = '/edge/coupon/Redemption/List';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'RedemptionListRequestModel' is not null or undefined
        if (RedemptionListRequestModel === null || RedemptionListRequestModel === undefined) {
            throw new Error('Required parameter RedemptionListRequestModel was null or undefined when calling redemptionList.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(RedemptionListRequestModel, "RedemptionListRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "CouponRedemptionListListResponse");
        }
        return response;
    }
};
EdgeCouponApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeCouponApi);
export { EdgeCouponApi };
//# sourceMappingURL=edgeCouponApi.js.map